import type { DocumentsTableSettings } from '~/features/home/documents/homeDocuments';
import type { CompanyHomeSettings } from '~/features/home/utils/companyHomeSettings';

import { pilotV3 } from '~/services/serviceInstances';

type UpdateRequest = {
  settings: CompanyHomeSettings;
};

type ServerUpdateRequest = {
  settings: CompanyHomeSettings;
};

type CompanyHomeDefaults = {
  documents: DocumentsTableSettings;
};

// Pilot sends the publisher fields and the product defaults only to someone
// who can edit; everyone else gets null.
type ServerResponse = {
  settings: unknown;
  published_at: string | null;
  published_by_id: number | null;
  published_by_name: string | null;
  can_edit: boolean;
  defaults?: CompanyHomeDefaults | null;
};

export type CompanyHomeSettingsResponse = {
  settings: unknown;
  publishedAt: string | null;
  publishedById: number | null;
  publishedByName: string | null;
  canEdit: boolean;
  defaults: CompanyHomeDefaults | null;
};

const mapUpdateRequest = ({
  settings,
}: UpdateRequest): ServerUpdateRequest => ({
  settings,
});

const mapResponse = (
  response: ServerResponse,
): CompanyHomeSettingsResponse => ({
  settings: response.settings ?? null,
  publishedAt: response.published_at ?? null,
  publishedById: response.published_by_id ?? null,
  publishedByName: response.published_by_name ?? null,
  canEdit: response.can_edit === true,
  defaults: response.defaults ?? null,
});

export const getCompanyHomeSettings = async (
  _?: void,
): Promise<CompanyHomeSettingsResponse> => {
  const response: ServerResponse = await pilotV3.get('/home/company-settings/');
  return mapResponse(response);
};

export const updateCompanyHomeSettings = async (
  request: UpdateRequest,
): Promise<CompanyHomeSettingsResponse> => {
  const response: ServerResponse = await pilotV3.put(
    '/home/company-settings/',
    mapUpdateRequest(request),
  );
  return mapResponse(response);
};
